import {Component, OnInit, ViewChild} from '@angular/core';
import {MatTableDataSource} from "@angular/material/table";
import {DataOperationService} from "../utils/data-services/data-operation.service";
import {ActivatedRoute, Router} from "@angular/router";
import {DataConcessionService} from "../utils/data-services/dataConcession.service";
import {MatPaginator} from "@angular/material/paginator";
import {DataFileService} from "../utils/data-services/data-file.service";
import swal from "sweetalert2";

@Component({
  selector: 'app-gestion-fichier',
  templateUrl: './gestion-fichier.component.html',
  styleUrls: ['./gestion-fichier.component.scss']
})
export class GestionFichierComponent implements OnInit {
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  dataSource = new MatTableDataSource();
  displayedColumns: string[] = ['type', 'name', 'date', 'delete'];
  active: boolean[] = [true, false];

  constructor(private dataService: DataFileService, private route: Router) { }

  ngOnInit() {
    this.getFilesInfos();
    this.paginator.pageIndex = localStorage.getItem('') != null ? parseInt(localStorage.getItem('')) : null;
    this.paginator.pageSize = localStorage.getItem('') != null ? parseInt(localStorage.getItem('')) : null;
    this.dataSource.paginator = this.paginator;
  }
  getFilesInfos(): void {
    this.dataService.getFilesInfos().subscribe(infos => {
      this.dataSource.data = infos;
    });
  }
  addFile() {
    this.route.navigate(['../upload-fichiers/']);
  }
  // downloadFile(id: number, type: string) {
  //   if (type === 'certificate') {
  //     this.dataService.downloadCertificateById(id).subscribe();
  //   } else if (type === 'job') {
  //     this.dataService.downloadPmaj(id).subscribe();
  //   }
  // }
  deleteFile(id: number, type: string) {
    swal.fire({
      title: 'Attention!',
      text: 'Vous êtes sur le point de supprimer un fichier, êtes-vous sûr de vouloir continuer?',
      type: 'warning',
      confirmButtonText: 'Ok',
      showCancelButton: true,
      cancelButtonText: 'Annuler'
    }).then((result) => {
      if (result.value) {
        if (type === 'certificate') {
          this.dataService.deleteCertificate(id).subscribe(() => {
            this.getFilesInfos();
          });
        } else if (type === 'job') {
          this.dataService.deletePmaj(id).subscribe(() => {
            this.getFilesInfos();
          });
        }
      }
    });
  }
  getPageSizeOptions(): number[] {
    if (this.dataSource && this.dataSource.data.length > 100 && this.dataSource.paginator) {
      return [20, 50, 100,  this.dataSource.paginator.length];
    } else {
      return [20, 50, 100];
    }
  }
  displayPaginatorAllOption() {
    const matOptions = document.getElementsByClassName('mat-option-text');
    // @ts-ignore
    for (const options of matOptions) {
      options.innerHTML = options.innerHTML == this.dataSource.data.length ? 'Tous' : options.innerHTML;
    }
  }
  pageChange() {
    localStorage.setItem('pageIndexOperation', String(this.paginator.pageIndex));
    localStorage.setItem('pageSizeOperation', String(this.paginator.pageSize));
  }
}
